import { TTheme } from '@/core/theme'
import Typography from '@/ui/components/typography'
import { styled } from '@mui/system'

export const Wrapper = styled('div')``

export const StepWrapper = styled('div')`
    display: flex;
    margin-bottom: 24px;
`

export const StepIndicator = styled(Typography)<{ theme?: TTheme }>`
    background-color: ${({ theme }) => theme.colors.greys[50]};
    border-radius: 50%;
    margin-right: 16px;
    text-align: center;
    padding-top: 4px;
    width: 28px;
    height: 28px;
    aspect-ratio: 1;
`
